export default __webpack_public_path__ + "static/media/dart.f00251a3.png";